/* -- Circle Flags -- */
import { default as CircleFlagsRu } from '~icons/circle-flags/ru';
import { default as CircleFlagsUs } from '~icons/circle-flags/us';
/* -- FA -- */
import { default as FaAngleLeft } from '~icons/fa/angle-left';
/* -- Lucide -- */
import { default as LucideAtSign } from '~icons/lucide/at-sign';
import { default as LucideBell } from '~icons/lucide/bell';
import { default as LucideBellOff } from '~icons/lucide/bell-off';
import { default as LucideCalendarClock } from '~icons/lucide/calendar-clock';
import { default as LucideCheck } from '~icons/lucide/check';
import { default as LucideCheckCheck } from '~icons/lucide/check-check';
import { default as LucideChevronLeft } from '~icons/lucide/chevron-left';
import { default as LucideChevronRight } from '~icons/lucide/chevron-right';
import { default as LucideClock3 } from '~icons/lucide/clock-3';
import { default as LucideDownload } from '~icons/lucide/download';
import { default as LucideEllipsisVertical } from '~icons/lucide/ellipsis-vertical';
import { default as LucideExternalLink } from '~icons/lucide/external-link';
import { default as LucideFile } from '~icons/lucide/file';
import { default as LucideInfo } from '~icons/lucide/info';
import { default as LucideKeyboard } from '~icons/lucide/keyboard';
import { default as LucideMessageCircle } from '~icons/lucide/message-circle';
import { default as LucideMonitor } from '~icons/lucide/monitor';
import { default as LucideMonitorSmartphone } from '~icons/lucide/monitor-smartphone';
import { default as LucidePalette } from '~icons/lucide/palette';
import { default as LucidePaperclip } from '~icons/lucide/paperclip';
import { default as LucideReply } from '~icons/lucide/reply';
import { default as LucideRotateCcw } from '~icons/lucide/rotate-ccw';
import { default as LucideSmartphone } from '~icons/lucide/smartphone';
import { default as LucideSmile } from '~icons/lucide/smile';
import { default as LucideSmilePlus } from '~icons/lucide/smile-plus';
import { default as LucideX } from '~icons/lucide/x';
/* -- MaterialSymbols -- */
import { default as MaterialSymbolsCheck } from '~icons/material-symbols/check';
import { default as MaterialSymbolsClose } from '~icons/material-symbols/close';
import { default as MaterialSymbolsContentCopyOutline } from '~icons/material-symbols/content-copy-outline';
import { default as MaterialSymbolsDeleteOutline } from '~icons/material-symbols/delete-outline';
import { default as MaterialSymbolsEdit } from '~icons/material-symbols/edit';
import { default as MaterialSymbolsLogout } from '~icons/material-symbols/logout';
import { default as MaterialSymbolsSettings } from '~icons/material-symbols/settings';
import { default as MaterialSymbolsTranslate } from '~icons/material-symbols/translate';
/* -- Mdi -- */
import { default as MdiAccount } from '~icons/mdi/account';
import { default as MdiAndroid } from '~icons/mdi/android';
import { default as MdiApple } from '~icons/mdi/apple';
import { default as MdiAppleIos } from '~icons/mdi/apple-ios';
import { default as MdiEyeOffOutline } from '~icons/mdi/eye-off-outline';
import { default as MdiEyeOutline } from '~icons/mdi/eye-outline';
import { default as MdiKeyOutline } from '~icons/mdi/key-outline';
import { default as MdiLinux } from '~icons/mdi/linux';
import { default as MdiMagnify } from '~icons/mdi/magnify';
import { default as MdiMicrosoftWindows } from '~icons/mdi/microsoft-windows';
/* -- Mingcute -- */
import { default as MingcuteDownFill } from '~icons/mingcute/down-fill';
import { default as MingcuteSendFill } from '~icons/mingcute/send-fill';
import { default as SelfhstFirefox } from '~icons/selfhst/firefox';
import { default as SelfhstGoogle } from '~icons/selfhst/google';
/* -- selfh.st -- */
import { default as SelfhstChrome } from '~icons/selfhst/google-chrome';
import { default as SelfhstEdge } from '~icons/selfhst/microsoft-edge';
import { default as SelfhstOpera } from '~icons/selfhst/opera';
import { default as SelfhstSafari } from '~icons/selfhst/safari';
import { default as SelfhstYandex } from '~icons/selfhst/yandex';

enum IconFamily {
  CIRCLE_FLAGS = 'circle-flags',
  MATERIAL_DESIGN_SYMBOLS = 'material-symbols',
  MATERIAL_DESIGN_ICONS = 'mdi',
  FONT_AWESOME = 'fa',
  LUCIDE = 'lucide',
  SELF_HOSTED = 'selfhst',
  MINGCUTE = 'mingcute',
}

const ICON_FAMILIES = {
  [IconFamily.CIRCLE_FLAGS]: {
    ru: CircleFlagsRu,
    us: CircleFlagsUs,
  },

  [IconFamily.MATERIAL_DESIGN_SYMBOLS]: {
    check: MaterialSymbolsCheck,
    close: MaterialSymbolsClose,
    'content-copy-outline': MaterialSymbolsContentCopyOutline,
    'delete-outline': MaterialSymbolsDeleteOutline,
    logout: MaterialSymbolsLogout,
    settings: MaterialSymbolsSettings,
    translate: MaterialSymbolsTranslate,
    edit: MaterialSymbolsEdit,
  },

  [IconFamily.MATERIAL_DESIGN_ICONS]: {
    account: MdiAccount,
    android: MdiAndroid,
    apple: MdiApple,
    'apple-ios': MdiAppleIos,
    'eye-off-outline': MdiEyeOffOutline,
    'eye-outline': MdiEyeOutline,
    'key-outline': MdiKeyOutline,
    magnify: MdiMagnify,
    linux: MdiLinux,
    'microsoft-windows': MdiMicrosoftWindows,
  },

  [IconFamily.FONT_AWESOME]: {
    'angle-left': FaAngleLeft,
  },

  [IconFamily.LUCIDE]: {
    'at-sign': LucideAtSign,
    bell: LucideBell,
    'bell-off': LucideBellOff,
    'calendar-clock': LucideCalendarClock,
    check: LucideCheck,
    'check-check': LucideCheckCheck,
    'chevron-left': LucideChevronLeft,
    'chevron-right': LucideChevronRight,
    'clock-3': LucideClock3,
    download: LucideDownload,
    'ellipsis-vertical': LucideEllipsisVertical,
    'external-link': LucideExternalLink,
    file: LucideFile,
    info: LucideInfo,
    keyboard: LucideKeyboard,
    monitor: LucideMonitor,
    'monitor-smartphone': LucideMonitorSmartphone,
    'message-circle': LucideMessageCircle,
    paperclip: LucidePaperclip,
    palette: LucidePalette,
    'rotate-ccw': LucideRotateCcw,
    reply: LucideReply,
    smile: LucideSmile,
    'smile-plus': LucideSmilePlus,
    smartphone: LucideSmartphone,
    x: LucideX,
  },

  [IconFamily.SELF_HOSTED]: {
    chrome: SelfhstChrome,
    firefox: SelfhstFirefox,
    google: SelfhstGoogle,
    'microsoft-edge': SelfhstEdge,
    opera: SelfhstOpera,
    safari: SelfhstSafari,
    yandex: SelfhstYandex,
  },

  [IconFamily.MINGCUTE]: {
    'send-fill': MingcuteSendFill,
    'down-fill': MingcuteDownFill,
  },
} as const;

export { IconFamily, ICON_FAMILIES };
